function queryFromSearch(search) {
  const q = search.startsWith('?') ? search.slice(1) : search;
  return new URLSearchParams(q);
}

function isRobotmonHost(hostname) {
  return hostname === 'robotmon.app' || hostname.endsWith('.robotmon.app');
}

function isExternalReferrer(referrer) {
  if (!referrer) return false;
  try {
    const host = new URL(referrer).hostname;
    if (!host) return false;
    return !isRobotmonHost(host);
  } catch (e) {
    return false;
  }
}

function mapLandingLocale(raw) {
  const lower = raw.toLowerCase();
  if (lower === 'ja' || lower.startsWith('ja-')) return 'ja';
  if (lower === 'ko' || lower.startsWith('ko-')) return 'ko';
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (lower.startsWith('zh')) return 'zh-hant';
  return null;
}

function resolveLandingLocale(langParam, i18nLanguage) {
  if (langParam) {
    const mapped = mapLandingLocale(langParam);
    return mapped !== null ? mapped : 'en';
  }
  const mapped = mapLandingLocale(i18nLanguage);
  return mapped !== null ? mapped : 'en';
}

function resolveSlug(game) {
  if (!game) return null;
  const lower = game.toLowerCase();
  if (lower === 'tsum') return 'tsum';
  if (lower === 'mlb9i') return 'mlb9i';
  if (lower === 'cookiekingdom' || lower === 'crk') return 'cookie-kingdom';
  return null;
}

export function resolveBounceTarget(input) {
  const referrer = input.referrer;
  const search = input.search;
  const i18nLanguage = input.i18nLanguage;
  const alreadyBounced = input.alreadyBounced !== undefined ? input.alreadyBounced : false;
  const landedPathname = input.landedPathname !== undefined ? input.landedPathname : '/login';

  if (alreadyBounced) return null;
  if (landedPathname.replace(/\/+$/, '') !== '/login') return null;
  if (!isExternalReferrer(referrer)) return null;

  const params = queryFromSearch(search);
  if (params.get('from') === 'landing') return null;

  const locale = resolveLandingLocale(params.get('lang'), i18nLanguage);
  const slug = resolveSlug(params.get('game'));

  params.delete('game');
  params.delete('lang');
  params.delete('from');
  const qs = params.toString();
  const path = slug ? '/' + locale + '/' + slug : '/' + locale;
  return 'https://web.robotmon.app' + path + (qs ? '?' + qs : '');
}
